exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_slides_2kv61kU5Lp4X3JVaK854d0 {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_BZ_XMLR5p57MkiNmqrpGm {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_3DALDKVc4Nn3TLZTr7Zz1o {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_3w4x7aeskL9buUMIcSNlEB {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_slides": "IA_slides_2kv61kU5Lp4X3JVaK854d0",
	"IA_filters": "IA_filters_BZ_XMLR5p57MkiNmqrpGm",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_3DALDKVc4Nn3TLZTr7Zz1o",
	"IA_paginationPageCount": "IA_paginationPageCount_3w4x7aeskL9buUMIcSNlEB"
};